<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات پرسنلی</h5>
      <form [formGroup]="AddNewPerson">

        <input type="hidden" formControlName="id" />

        <br>
        <br>
        <h4>اطلاعات پرسنلی</h4>
        <br>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">نام (*)</label>
            <input formControlName="fname" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_fname().valid && get_Form_fname().touched" class="form-text text-muted MyErrorRedColor">نام را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">نام خانوادگی (*)</label>
            <input formControlName="lname" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_lname().valid && get_Form_lname().touched" class="form-text text-muted MyErrorRedColor">نام خانوادگی را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> جنسیت </label>
            <select class="custom-select" formControlName="sex">
              <option value="0">انتخاب کنید</option>
              <option value="1">مرد</option>
              <option value="2">زن</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">وضیعت تأهل</label>
            <select class="custom-select" formControlName="vaziat_Tahol"  >
              <option value="0">انتخاب کنید</option>
              <option value="1">متأهل</option>
              <option value="2">مجرد</option>
            </select>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">استان </label>
            <select class="custom-select" formControlName="ProvinceId"  (change)="ProvinceChange()">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">محل صدور</label>
            <select class="custom-select" formControlName="mahal_tavalod">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">شماره شناسنامه</label>
            <input formControlName="shomareh_Shenasnameh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">شماره سری شناسنامه</label>
            <input formControlName="shomareh_Shenasnameh_Seri" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">کد ملّی (بدون صفر اول)</label>
            <input formControlName="codeMeli" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_codeMeli().valid && get_Form_codeMeli().touched" class="form-text text-muted MyErrorRedColor">کد ملی را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">شماره بیمه</label>
            <input formControlName="shomareh_bimeh" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">پدر</label>
            <input formControlName="name_Pedar" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">شغل پدر</label>
            <input formControlName="shoghleh_Pedar" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              شماره همراه (بدون صفر اول)
              <button (click)="OnAdd_shomareh_Hamreh()"  type="button" [disabled]="!get_Form_shomareh_Hamreh().valid || get_Form_shomareh_Hamreh().value =='' || get_Form_shomareh_Hamreh().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="shomareh_Hamreh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_shomareh_Hamreh().valid && get_Form_shomareh_Hamreh().touched" class="form-text text-muted MyErrorRedColor">شماره همراه را وارد نمائید.</small>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_shomareh_Hamreh_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_shomareh_Hamreh_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_shomareh_Hamreh_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">مسکن </label>
            <select class="custom-select" formControlName="maskan"  >
              <option value="0">انتخاب کنید</option>
              <option value="1">شخصی</option>
              <option value="2">استیجاری</option>
              <option value="3">با اقوام زندگی می‌کند</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              ایمیل
              <button (click)="OnAdd_email()"  type="button" [disabled]="!get_Form_email().valid || get_Form_email().value =='' || get_Form_email().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="email" type="email" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_email().valid && get_Form_email().touched" class="form-text text-muted MyErrorRedColor">ایمیل را وارد نمائید.</small>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_email_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_email_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_email_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>



        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              آدرس منزل فعلی
              <button (click)="OnAdd_address_Manzel()"  type="button" [disabled]="!get_Form_address_Manzel().valid || get_Form_address_Manzel().value =='' || get_Form_address_Manzel().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="address_Manzel" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_address_Manzel_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_address_Manzel_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_address_Manzel_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              کدپستی
              <button (click)="OnAdd_codeposti()"  type="button" [disabled]="!get_Form_codeposti().valid || get_Form_codeposti().value =='' || get_Form_codeposti().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="codeposti" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_codeposti_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_codeposti_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_codeposti_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              تلفن
              <button (click)="OnAdd_tel()"  type="button" [disabled]="!get_Form_tel().valid || get_Form_tel().value =='' || get_Form_tel().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="tel" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_tel_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_tel_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_tel_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>

        </div>

        <div class="row" [hidden]="get_Form_Sex().value!='1'">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">وضعیت نظام وظیفه</label>
            <select class="custom-select" formControlName="vaziat_Nazam_Vazifeh"  >
              <option value="0">انتخاب کنید</option>
              <option value="1">شده</option>
              <option value="2">معافیت موقت</option>
              <option value="3">معافیت دائمی</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">توضیحات وضعیت نظام وظیفه</label>
            <input formControlName="vaziat_Nazam_Vazifeh_Dsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">از تاریخ </label>
            <input formControlName="vaziat_startDate" #vaziat_startDateInput type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_startDateInput"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">تا تاریخ </label>
            <input formControlName="vaziat_endDate" #vaziat_endDateInput type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_endDateInput"></ng-persian-datepicker>
          </div>

        </div>

        <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">نام همسر</label>
            <input formControlName="name_Hamsar" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">تعداد فرزندان</label>
            <input formControlName="tedadFarzandan" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">کد ملّی همسر (بدون صفر اول) </label>
            <input formControlName="codeMeli_Hamsar" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_codeMeli_Hamsar().valid && get_Form_codeMeli_Hamsar().touched" class="form-text text-muted MyErrorRedColor">کد ملّی همسر را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              شماره همراه همسر (بدون صفر اول)
              <button (click)="OnAdd_shomareh_hamrah_Hamsar()"  type="button" [disabled]="!get_Form_shomareh_hamrah_Hamsar().valid || get_Form_shomareh_hamrah_Hamsar().value =='' || get_Form_shomareh_hamrah_Hamsar().value == null "  class="btn  btn-success" ><i class="fa  fa-plus-circle"></i> </button>
            </label>
            <input formControlName="shomareh_hamrah_Hamsar" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_shomareh_hamrah_Hamsar().valid && get_Form_shomareh_hamrah_Hamsar().touched" class="form-text text-muted MyErrorRedColor">شماره همراه همسر را وارد نمائید.</small>
            <table class="mb-0 table table-bordered table-3 text-center table-striped" *ngIf="Person_shomareh_hamrah_Hamsar_Array.length>0">
              <tr class="bg-warning" *ngFor="let item of Person_shomareh_hamrah_Hamsar_Array">
                  <td>
                    {{item.title}}
                  </td>
                  <td>
                    <a style="cursor: pointer;"  (click)="Person_shomareh_hamrah_Hamsar_Delete(item.id)"><i class="fa fa-remove"></i> حذف </a>
                  </td>
              </tr>
            </table>
          </div>

        </div>

        <div class="row" [hidden]="get_Form_vaziat_Tahol().value!='1'">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تحصیلات همسر</label>
            <select class="custom-select" formControlName="tahsilat_Hamsar"  >
              <option value="0">انتخاب کنید</option>
              <option value="1">سیکل</option>
              <option value="2">دیپلم</option>
              <option value="3">کاردانی</option>
              <option value="4">کارشناسی</option>
              <option value="5">کارشناسی ارشد</option>
              <option value="6">دکتری</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تاریخ تولد همسر</label>
            <input formControlName="tarikh_Tavalod_Hamsar" #tarikh_Tavalod_HamsarInput type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_HamsarInput"></ng-persian-datepicker>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">شغل همسر</label>
            <input formControlName="shoghleh_Hamsar" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

        </div>

        <div class="row" >
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تاریخ تولد </label>
            <input formControlName="tarikh_Tavalod" #tarikh_Tavalod_Input type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_Tavalod_Input"></ng-persian-datepicker>
          </div>
        </div>

        <br>
        <br>
        <hr>
        <br>
        <h4>بارگذاری مدارک</h4>
        <br>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              کارت ملی1
              <button (click)="Remove_uploadcodemeli_Image1()"  type="button" *ngIf="Add_Record_Persone.codemeli_Image1"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_codemeli_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_codemeli_Image1" #file_codemeli_Image1 (change)="uploadcodemeli_Image1(file_codemeli_Image1.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.codemeli_Image1)" *ngIf="Add_Record_Persone.codemeli_Image1" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.codemeli_Image1}}"/>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              کارت ملی2
              <button (click)="Remove_uploadcodemeli_Image2()"  type="button" *ngIf="Add_Record_Persone.codemeli_Image2"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_codemeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_codemeli_Image2" #file_codemeli_Image2 (change)="uploadcodemeli_Image2(file_codemeli_Image2.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.codemeli_Image2)" *ngIf="Add_Record_Persone.codemeli_Image2" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.codemeli_Image2}}"/>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              شناسنامه 1
              <button (click)="Remove_uploadshenasNameh_Image1()"  type="button" *ngIf="Add_Record_Persone.shenasNameh_Image1"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_shenasNameh_Image1" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_shenasNameh_Image1" #file_shenasNameh_Image1 (change)="uploadshenasNameh_Image1(file_shenasNameh_Image1.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.shenasNameh_Image1)" *ngIf="Add_Record_Persone.shenasNameh_Image1" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.shenasNameh_Image1}}"/>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              شناسنامه 2
              <button (click)="Remove_uploadshenasNameh_Image2()"  type="button" *ngIf="Add_Record_Persone.shenasNameh_Image2"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_shenasNameh_Image2" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_shenasNameh_Image2" #file_shenasNameh_Image2 (change)="uploadshenasNameh_Image2(file_shenasNameh_Image2.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.shenasNameh_Image2)" *ngIf="Add_Record_Persone.shenasNameh_Image2" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.shenasNameh_Image2}}"/>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              شناسنامه 3
              <button (click)="Remove_uploadshenasNameh_Image3()"  type="button" *ngIf="Add_Record_Persone.shenasNameh_Image3"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_shenasNameh_Image3" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_shenasNameh_Image3" #file_shenasNameh_Image3 (change)="uploadshenasNameh_Image3(file_shenasNameh_Image3.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.shenasNameh_Image3)" *ngIf="Add_Record_Persone.shenasNameh_Image3" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.shenasNameh_Image3}}"/>
          </div>

        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              کارت پایان خدمت
              <button (click)="Remove_uploadkartPayan_Khadamt_Image()"  type="button" *ngIf="Add_Record_Persone.kartPayan_Khadamt_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_kartPayan_Khadamt_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_kartPayan_Khadamt_Image" #file_kartPayan_Khadamt_Image (change)="uploadkartPayan_Khadamt_Image(file_kartPayan_Khadamt_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.kartPayan_Khadamt_Image)" *ngIf="Add_Record_Persone.kartPayan_Khadamt_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.kartPayan_Khadamt_Image}}"/>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">
              فرم سوء پیشینه
              <button (click)="Remove_uploadform_soe_Pishineh_Image()"  type="button" *ngIf="Add_Record_Persone.form_soe_Pishineh_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_form_soe_Pishineh_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_form_soe_Pishineh_Image" #file_form_soe_Pishineh_Image (change)="uploadform_soe_Pishineh_Image(file_form_soe_Pishineh_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.form_soe_Pishineh_Image)" *ngIf="Add_Record_Persone.form_soe_Pishineh_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.form_soe_Pishineh_Image}}"/>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              عکس پرسنلی
              <button (click)="Remove_uploadax_Personeli_Image()"  type="button" *ngIf="Add_Record_Persone.ax_Personeli_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Personeli_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Personeli_Image" #file_ax_Personeli_Image (change)="uploadax_Personeli_Image(file_ax_Personeli_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.ax_Personeli_Image)" *ngIf="Add_Record_Persone.ax_Personeli_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.ax_Personeli_Image}}"/>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              عکس پرسنلی2
              <button (click)="Remove_uploadax_Personeli_Image2()"  type="button" *ngIf="Add_Record_Persone.ax_Personeli_Image2"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Personeli_Image2" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Personeli_Image2" #file_ax_Personeli_Image2 (change)="uploadax_Personeli_Image2(file_ax_Personeli_Image2.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.ax_Personeli_Image2)" *ngIf="Add_Record_Persone.ax_Personeli_Image2" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.ax_Personeli_Image2}}"/>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              امضاء
              <button (click)="Remove_uploadax_Sign_Image()"  type="button" *ngIf="Add_Record_Persone.sign_image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Sign_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Sign_Image" #file_ax_Sign_Image (change)="uploadax_Sign_Image(file_ax_Sign_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.sign_image)" *ngIf="Add_Record_Persone.sign_image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.sign_image}}"/>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              فرم رزومه برای مصاحبه
              <button (click)="Remove_uploadform_reserve_mosahebeh_Image()"  type="button" *ngIf="Add_Record_Persone.form_reserve_mosahebeh_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_form_reserve_mosahebeh_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_form_reserve_mosahebeh_Image" #file_form_reserve_mosahebeh_Image (change)="uploadform_reserve_mosahebeh_Image(file_form_reserve_mosahebeh_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,Add_Record_Persone.form_reserve_mosahebeh_Image)" *ngIf="Add_Record_Persone.form_reserve_mosahebeh_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{Add_Record_Persone.form_reserve_mosahebeh_Image}}"/>
          </div>
        </div>

        <br>
        <br>
        <hr>
        <br>
        <h4>جایگاه در بهینه فرآیند آزما</h4>
        <br>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">تاریخ استخدام در بهینه (*)</label>
            <input formControlName="tarikh_Eshtekhdam" #tarikh_EshtekhdamInput type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="tarikh_EshtekhdamInput"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">علامت اختصاری در بهینه فرآیند آزما (*)</label>
            <input formControlName="almat_Ekhtesari" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_almat_Ekhtesari().valid && get_Form_almat_Ekhtesari().touched" class="form-text text-muted MyErrorRedColor">علامت اختصاری در بهینه فرآیند آزما را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">سابق قبل بهفا(سال)</label>
            <input formControlName="sabegh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">محل فعالیت</label>
            <select class="custom-select" formControlName="field_activity_id"  >
              <option value="0">انتخاب کنید</option>
              <option value="1">داخل آزمایشگاه</option>
              <option value="2">خارج آزمایشگاه</option>
              <option value="3">داخل/خارج آزمایشگاه</option>
              <option value="4">اداری</option>
              <option value="5">مالی</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">سمت</label>
            <select class="custom-select" formControlName="semat_id"  >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Semat" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
        </div>



      </form>

      <br>
      <br>
      <hr>
      <br>

      <form [formGroup]="Form_List_Hasilat_Record" (submit)="onSubmitTahsimla()" >
        <h4>تحصیلات</h4>
        <br>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">از سال/ماه</label>
            <input formControlName="date_starrt"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_date_starrt().valid && get_Form_List_Hasilat_Record_date_starrt().touched" class="form-text text-muted MyErrorRedColor">از سال/ماه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">تا سال/ماه</label>
            <input formControlName="date_end"   type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_date_end().valid && get_Form_List_Hasilat_Record_date_end().touched" class="form-text text-muted MyErrorRedColor">تا سال/ماه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">مقطع</label>
            <input formControlName="degree"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_degree().valid && get_Form_List_Hasilat_Record_degree().touched" class="form-text text-muted MyErrorRedColor">مقطع را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">رشته تحصیلی</label>
            <input formControlName="reshteh"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_reshteh().valid && get_Form_List_Hasilat_Record_reshteh().touched" class="form-text text-muted MyErrorRedColor">رشته تحصیلی را وارد نمائید.</small>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">گرایش</label>
            <input formControlName="grayesh"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_grayesh().valid && get_Form_List_Hasilat_Record_grayesh().touched" class="form-text text-muted MyErrorRedColor">گرایش را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">دانشگاه/موسسه آموزش عالی</label>
            <input formControlName="uni"   type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_uni().valid && get_Form_List_Hasilat_Record_uni().touched" class="form-text text-muted MyErrorRedColor">دانشگاه/موسسه آموزش عالی را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">معدل</label>
            <input formControlName="moadel"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Hasilat_Record_moadel().valid && get_Form_List_Hasilat_Record_moadel().touched" class="form-text text-muted MyErrorRedColor">معدل را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">
              بارگذاری مدرک تحصیلی
              <button (click)="Remove_uploadax_Hasilat_Image()"  type="button" *ngIf="ax_Hasilat_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Hasilat_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Hasilat_Image" #file_ax_Hasilat_Image (change)="uploadax_Hasilat_Image(file_ax_Hasilat_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,ax_Hasilat_Image)" *ngIf="ax_Hasilat_Image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Hasilat_Image}}"/>
          </div>
        </div>

        <button  type="submit" [disabled]="!Form_List_Hasilat_Record.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات تحصیلی </button>

      </form>

      <div class="table-responsive" *ngIf="Data_Tahsilat_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>از سال/ماه</th>
              <th>تا سال/ماه</th>
              <th>مقطع</th>
              <th>رشته تحصیلی</th>
              <th>گرایش</th>
              <th>دانشگاه/موسسه آموزش عالی</th>
              <th>معدل</th>
              <th>مدرک تحصیلی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_Tahsilat_List">
             <td>{{Data_Tahsilat_List.indexOf(item)+1}}</td>
              <td>{{item.date_starrt}}</td>
              <td>{{item.date_end}}</td>
              <td>{{item.degree}}</td>
              <td>{{item.reshteh}}</td>
              <td>{{item.grayesh}}</td>
              <td>{{item.uni}}</td>
              <td>{{item.moadel}}</td>
              <td>
                <img (click)="openModal(templateImage,item.image)" *ngIf="item.image" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}"/>
              </td>

              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="RemoveTahsimla(Data_Tahsilat_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>

     <br>
     <br>
     <hr>
     <br>

     <form [formGroup]="Form_List_kari_Record" (submit)="onSubmitkari()" >
      <h4>سوابق کاری(5 سال گذشته)</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">از سال/ماه</label>
          <input formControlName="date_starrt"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_date_starrt().valid && get_Form_List_kari_Record_date_starrt().touched" class="form-text text-muted MyErrorRedColor">از سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تا سال/ماه</label>
          <input formControlName="date_end"   type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_date_end().valid && get_Form_List_kari_Record_date_end().touched" class="form-text text-muted MyErrorRedColor">تا سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام شرکت/سازمان</label>
          <input formControlName="companyName"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_companyName().valid && get_Form_List_kari_Record_companyName().touched" class="form-text text-muted MyErrorRedColor">نام شرکت/سازمان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نوع استخدام</label>
          <input formControlName="type"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_type().valid && get_Form_List_kari_Record_type().touched" class="form-text text-muted MyErrorRedColor">نوع استخدام را وارد نمائید.</small>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">سمت</label>
          <input formControlName="semat"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_semat().valid && get_Form_List_kari_Record_semat().touched" class="form-text text-muted MyErrorRedColor">سمت را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">علت ترک خدمت</label>
          <input formControlName="leave"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_leave().valid && get_Form_List_kari_Record_leave().touched" class="form-text text-muted MyErrorRedColor">علت ترک خدمت را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تلفن</label>
          <input formControlName="tel"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_tel().valid && get_Form_List_kari_Record_tel().touched" class="form-text text-muted MyErrorRedColor">تلفن را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">آدرس</label>
          <input formControlName="address"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_address().valid && get_Form_List_kari_Record_address().touched" class="form-text text-muted MyErrorRedColor">آدرس را وارد نمائید.</small>
        </div>
      </div>

      <button  type="submit" [disabled]="!Form_List_kari_Record.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات سوابق کاری </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Kari_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>از سال/ماه</th>
            <th>تا سال/ماه</th>
            <th>نام شرکت/سازمان</th>
            <th>نوع استخدام</th>
            <th>سمت</th>
            <th>علت ترک خدمت</th>
            <th>تلفن</th>
            <th>آدرس</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Kari_List">
           <td>{{Data_Kari_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.companyName}}</td>
            <td>{{item.type}}</td>
            <td>{{item.semat}}</td>
            <td>{{item.leave}}</td>
            <td>{{item.tel}}</td>
            <td>{{item.address}}</td>

            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="RemoveKari(Data_Kari_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>
            </div>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Amoozeshi_Record" (submit)="onSubmitAmozeshi()" >
        <h4>سوابق آموزش</h4>
        <br>
        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">از سال/ماه</label>
            <input formControlName="date_starrt"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_date_starrt().valid && get_Form_List_Amoozeshi_Record_date_starrt().touched" class="form-text text-muted MyErrorRedColor">از سال/ماه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">تا سال/ماه</label>
            <input formControlName="date_end"   type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_date_end().valid && get_Form_List_Amoozeshi_Record_date_end().touched" class="form-text text-muted MyErrorRedColor">تا سال/ماه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">سرفصل دوره آموزشی</label>
            <select class="custom-select" formControlName="sarFaslAmozeshi_id" (change)="ReadData_DorehAmoozeshi()">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_SarFaslAmozeshi" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1">عنوان دوره آموزشی</label>
            <select class="custom-select" formControlName="dorehAmoozeshi_id">
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_DorehAmoozeshi" [value]="item.id">{{item.title}}</option>
            </select>
          </div>

        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">مدت(ساعت)</label>
            <input formControlName="modat"  type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_modat().valid && get_Form_List_Amoozeshi_Record_modat().touched" class="form-text text-muted MyErrorRedColor">مدت(ساعت) را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">برگزار کننده</label>
            <input formControlName="bargozarKonnadeh"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_List_Amoozeshi_Record_bargozarKonnadeh().valid && get_Form_List_Amoozeshi_Record_bargozarKonnadeh().touched" class="form-text text-muted MyErrorRedColor">برگزار کننده را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">
              بارگذاری مدرک تحصیلی
              <button (click)="Remove_uploadax_Amoozeshi_Image()"  type="button" *ngIf="ax_Amoozeshi_Image"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
            </label>
            <img *ngIf="InProccessing_ax_Amoozeshi_Image" src="assets/Loading.gif" style="width: 25px;" />
            <input *ngIf="!InProccessing_ax_Amoozeshi_Image" #file_ax_Amoozeshi_Image (change)="uploadax_Amoozeshi_Image(file_ax_Amoozeshi_Image.files)" type="file" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <img (click)="openModal(templateImage,ax_Amoozeshi_Image)" *ngIf="ax_Amoozeshi_Image && !ax_Amoozeshi_Image.includes('.pdf')" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Amoozeshi_Image}}"/>
          </div>
        </div>

        <button  type="submit" [disabled]="!Form_List_Amoozeshi_Record.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات سوابق آموزش </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Amoozeshi_List.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>از سال/ماه</th>
              <th>تا سال/ماه</th>
              <th>سرفصل دوره آموزشی</th>
              <th>عنوان دوره آموزشی</th>
              <th>مدت(ساعت)</th>
              <th>برگزار کننده</th>
              <th>مدرک تحصیلی</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Data_Amoozeshi_List">
             <td>{{Data_Amoozeshi_List.indexOf(item)+1}}</td>
              <td>{{item.date_starrt}}</td>
              <td>{{item.date_end}}</td>
              <td>{{item.sarFaslAmozeshiTitle}}</td>
              <td>{{item.dorehAmoozeshiTitle}}</td>
              <td>{{item.modat}}</td>
              <td>{{item.bargozarKonnadeh}}</td>
              <td>
                <a target="_blank" *ngIf="item.image && item.image.includes('.pdf')" href="{{BaseUrl}}File/Person/{{item.image}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                <img *ngIf="item.image && !item.image.includes('.pdf')" (click)="openModal(templateImage,item.image)"  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}"/>
              </td>

              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" (click)="RemoveAmozeshi(Data_Amoozeshi_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                      </div>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>

     <br>
     <br>
     <hr>
     <br>

     <form [formGroup]="Form_List_Skill_Record" (submit)="onSubmitSkill()" >
       <h4>مهارت</h4>
       <br>
       <div class="row">

         <div class="form-group col-md-6">
           <label for="exampleInputEmail1">مهارت</label>
           <select class="custom-select" formControlName="skill">
             <option value="0">انتخاب کنید</option>
             <option *ngFor="let item of DataList_Skill" [value]="item.id">{{item.title}}</option>
           </select>
         </div>
         <div class="form-group col-md-6">
          <label for="exampleInputEmail1">درصد</label>
          <input formControlName="percent"  type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Skill_Record_percent().valid && get_Form_List_Skill_Record_percent().touched" class="form-text text-muted MyErrorRedColor">درصد را وارد نمائید.</small>
        </div>

       </div>

       <button  type="submit" [disabled]="!Form_List_Skill_Record.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات مهارت </button>

     </form>

     <div class="table-responsive" *ngIf="Data_Skill_List.length>0">
       <table class="mb-0 table table-bordered table-3 text-center table-striped">
         <thead style="background-color: #489b39; color: white;">
           <tr>
             <th>#</th>
             <th>مهارت</th>
             <th>درصد</th>
             <th>امکانات</th>
           </tr>
         </thead>
         <tbody>
           <tr *ngFor="let item of Data_Skill_List">
            <td>{{Data_Skill_List.indexOf(item)+1}}</td>
             <td>{{item.skillTitle}}</td>
             <td>{{item.percennt}}</td>
             <td>
               <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                 <div class="btn-group" role="group">
                     <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                         امکانات
                     </button>
                     <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                         <a style="cursor: pointer;" (click)="RemoveSkill(Data_Skill_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                     </div>
                 </div>
             </div>
             </td>

           </tr>
         </tbody>
       </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Tahghighat_Record" (submit)="onSubmitTahghighat()" >
      <h4>تحقیقات</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
         <label for="exampleInputEmail1">عنوان</label>
         <input formControlName="title"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
         <small *ngIf="!get_Form_List_Tahghighat_Record_title().valid && get_Form_List_Tahghighat_Record_title().touched" class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
       </div>
       <div class="form-group col-md-3">
        <label for="exampleInputEmail1">تاریخ</label>
        <input formControlName="tarikh"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        <small *ngIf="!get_Form_List_Tahghighat_Record_tarikh().valid && get_Form_List_Tahghighat_Record_tarikh().touched" class="form-text text-muted MyErrorRedColor">تاریخ را وارد نمائید.</small>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">ناشر</label>
        <input formControlName="nasher"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        <small *ngIf="!get_Form_List_Tahghighat_Record_nasher().valid && get_Form_List_Tahghighat_Record_nasher().touched" class="form-text text-muted MyErrorRedColor">ناشر را وارد نمائید.</small>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">لینک</label>
        <input formControlName="link"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        <small *ngIf="!get_Form_List_Tahghighat_Record_link().valid && get_Form_List_Tahghighat_Record_link().touched" class="form-text text-muted MyErrorRedColor">لینک را وارد نمائید.</small>
      </div>

      </div>

      <button  type="submit" [disabled]="!Form_List_Tahghighat_Record.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات تحقیق </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Tahghighat_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>عنوان</th>
            <th>تاریخ</th>
            <th>ناشر</th>
            <th>لینک</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Tahghighat_List">
           <td>{{Data_Tahghighat_List.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.tarikh}}</td>
            <td>{{item.nasher}}</td>
            <td>{{item.link}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="RemoveTahghighat(Data_Tahghighat_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>
            </div>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

   <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Document_Record" (submit)="onSubmitDocument()" >
      <h4>مطالعه و درک اسناد</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
         <label for="exampleInputEmail1">گروه اسناد</label>
         <select class="custom-select" formControlName="grpDoc_id" (change)="ReadData_DocumentTitle()">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_DocumentGroup" [value]="item.id">{{item.title}}</option>
        </select>
       </div>
       <div class="form-group col-md-3">
        <label for="exampleInputEmail1">عنوان سند</label>
        <select class="custom-select" formControlName="tlDoc_id">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_DocumentTitle" [value]="item.id">{{item.title}}</option>
        </select>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">شماره ویرایش</label>
        <input formControlName="shomareh"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        <small *ngIf="!get_Form_List_Document_Record_shomareh().valid && get_Form_List_Document_Record_shomareh().touched" class="form-text text-muted MyErrorRedColor">شماره ویرایش را وارد نمائید.</small>
      </div>
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">تأییدکننده</label>
        <input formControlName="taminKonandeh"  type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
        <small *ngIf="!get_Form_List_Document_Record_taminKonandeh().valid && get_Form_List_Document_Record_taminKonandeh().touched" class="form-text text-muted MyErrorRedColor">تأییدکننده را وارد نمائید.</small>
      </div>

      </div>

      <button  type="submit" [disabled]="!Form_List_Document_Record.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات مطالعه و درک اسناد </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Document_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>گروه اسناد</th>
            <th>عنوان سند</th>
            <th>شماره ویرایش</th>
            <th>تأییدکننده</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Document_List">
           <td>{{Data_Document_List.indexOf(item)+1}}</td>
            <td>{{item.grpDocTitle}}</td>
            <td>{{item.tlDocTitle}}</td>
            <td>{{item.shomareh}}</td>
            <td>{{item.taminKonandeh}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" (click)="RemoveDocument(Data_Document_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> حذف </a>
                    </div>
                </div>
            </div>
            </td>

          </tr>
        </tbody>
      </table>
   </div>

    <br>
    <br>

    <br>
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing"  (click)="SubmitAddNewPerson()" type="button" [disabled]="!AddNewPerson.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
    <button routerLink="/Person" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> نمایش عکس </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 350px;" src="{{BaseUrl}}File/Person/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Person/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> دانلود </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
